import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import { Grid, Slider } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";

type Props = {
  startTime: Date;
  endTime: Date;
  onTimeChange: (startTime: Date) => void;
};

const CustomTimeSlider = ({ startTime, endTime, onTimeChange }: Props) => {
  const [sliderValue, setSliderValue] = useState<number>(50);
  const [startLabel, setStartLabel] = useState<string>("");
  const [endLabel, setEndLabel] = useState<string>("");
  const [totalRange, setTotalRange] = useState<number>(0);

  const handleSliderChange = useCallback(
    (_event: Event, newValue: number | number[]): void => {
      const value = Array.isArray(newValue) ? newValue[0] : newValue;
      setSliderValue(value);

      const percentagePosition = value / 100;
      const newTimeValue =
        startTime.getTime() + totalRange * percentagePosition;
      const newTime = new Date(newTimeValue);
      onTimeChange(newTime);
    },
    [onTimeChange, startTime, totalRange],
  );

  const marks = useMemo(
    () => [
      {
        value: 0,
        label: startLabel,
      },
      {
        value: 100,
        label: endLabel,
      },
    ],
    [startLabel, endLabel],
  );

  useEffect(() => {
    if (startTime && endTime) {
      setStartLabel(dxtToLocalServerTime(startTime, "HH:mm:ss"));
      setEndLabel(dxtToLocalServerTime(endTime, "HH:mm:ss"));
      setTotalRange(endTime.getTime() - startTime.getTime());

      setSliderValue(50);
    }
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <Slider
          value={sliderValue}
          onChange={handleSliderChange}
          step={1}
          marks={marks}
          min={0}
          max={100}
          sx={{
            height: 8,
            "& .MuiSlider-thumb": {
              color: "primary.main",
              height: 20,
              width: 20,
            },
            "& .MuiSlider-track": {
              color: "primary.main",
              height: 8,
            },
            "& .MuiSlider-rail": {
              color: "success.main",
              height: 8,
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

export default CustomTimeSlider;
